import type { RouteObject } from "react-router-dom";

import { Outlet, redirect } from "react-router-dom";

import { Login } from "./ui/auth/login";
import { Users } from "./ui/users/users";
import { Planos } from "./ui/auth/planos";
import { Providers } from "./ui/providers";
import { Register } from "./ui/auth/register";
import { Profile } from "./ui/profile/profile";
import { History } from "./ui/history/history";
import { NotFound } from "./ui/shared/not-found";
import { Payments } from "./ui/profile/payments";
import { logout } from "./data/user/user.service";
import { Training } from "./ui/training/training";
import { AppLayout } from "./ui/layouts/app-layout";
import { Dashboard } from "./ui/dashboard/dashboard";
import { Scenarios } from "./ui/scenarios/scenarios";
import { AuthLayout } from "./ui/layouts/auth-layout";
import { ProfileForm } from "./ui/profile/profile-form";
import { ResetPassword } from "./ui/auth/reset-password";
import { queryClient } from "./ui/providers/query-client";
import { userQuery } from "./ui/shared/queries/user-query";
import { ForgotPassword } from "./ui/auth/forgot-password";
import { Checklist } from "./ui/admin/checklists/checklist";
import { Checklists } from "./ui/admin/checklists/checklists";
import { NavigationProgress } from "./ui/shared/navigation-progress";

export const routes: RouteObject[] = [
  {
    element: (
      <Providers>
        <NavigationProgress />
        <Outlet />
      </Providers>
    ),
    children: [
      {
        loader: async ({ request }) => {
          try {
            return await queryClient.ensureQueryData(userQuery);
          } catch {
            logout();
            queryClient.clear();
            sessionStorage.setItem("redirect", request.url);
            throw redirect("/entrar");
          }
        },
        element: <AppLayout />,
        children: [
          { index: true, element: <Dashboard /> },
          {
            path: "/cenarios",
            element: <Scenarios />,
          },
          {
            path: "/praticas/:id",
            element: <Training />,
          },
          {
            path: "/historico",
            element: <History />,
          },
          {
            path: "/colegas",
            element: <Users />,
          },

          {
            path: "/checklists",
            element: <Checklists />,
          },
          {
            path: "/checklists/:id",
            element: <Checklist />,
          },
          {
            path: "/perfil",
            element: <Profile />,
            children: [
              {
                index: true,
                element: <ProfileForm />,
              },
              {
                path: "pagamentos",
                element: <Payments />,
              },
            ],
          },
          { path: "*", element: <NotFound /> },
        ],
      },
      {
        element: <AuthLayout />,
        children: [
          { path: "cadastrar", element: <Register /> },
          { path: "entrar", element: <Login /> },
          { path: "recuperar-senha", element: <ForgotPassword /> },
          { path: "redefinir-senha", element: <ResetPassword /> },
          { path: "planos", element: <Planos /> },
        ],
      },
    ],
  },
];
